import { useState, useCallback } from 'react';

/**
 * Search Bar Component
 * Provides search, filter, and sort functionality
 */
export function SearchBar({ onSearchChange, onFilterChange, onSortChange }) {
  const [searchInput, setSearchInput] = useState('');

  // Debounced search
  const handleSearchInput = useCallback((e) => {
    const value = e.target.value;
    setSearchInput(value);

    // Debounce: wait 300ms after typing stops
    const timeoutId = setTimeout(() => {
      onSearchChange(value);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [onSearchChange]);

  // Priority filter change
  const handlePriorityChange = useCallback((e) => {
    onFilterChange('priority', e.target.value);
  }, [onFilterChange]);

  // Sort change
  const handleSortChange = useCallback((e) => {
    const value = e.target.value;
    const [sortBy, sortOrder] = value.split(':');
    onSortChange(sortBy, sortOrder || 'DESC');
  }, [onSortChange]);

  return (
    <div className="t24-search-bar">
      {/* Search Input */}
      <div className="t24-search-input-wrapper">
        <span className="t24-search-icon">🔍</span>
        <input
          type="text"
          className="t24-search-input"
          placeholder="Search proposals..."
          value={searchInput}
          onChange={handleSearchInput}
        />
        {searchInput && (
          <button
            className="t24-search-clear"
            onClick={() => {
              setSearchInput('');
              onSearchChange('');
            }}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>

      {/* Priority Filter */}
      <select
        className="t24-filter-select"
        onChange={handlePriorityChange}
        aria-label="Filter by priority"
      >
        <option value="">All Priorities</option>
        <option value="high">🔴 High Priority</option>
        <option value="medium">🟡 Medium Priority</option>
        <option value="low">🟢 Low Priority</option>
      </select>

      {/* Sort Selector */}
      <select
        className="t24-sort-select"
        onChange={handleSortChange}
        aria-label="Sort proposals"
      >
        <option value="created_at:DESC">📅 Latest First</option>
        <option value="created_at:ASC">📅 Oldest First</option>
        <option value="total_vote_weight:DESC">🔥 Most Voted</option>
        <option value="total_vote_weight:ASC">💤 Least Voted</option>
        <option value="title:ASC">🔤 A → Z</option>
        <option value="title:DESC">🔤 Z → A</option>
      </select>
    </div>
  );
}
